import React from 'react';
export function UrgencyBar() {
  return <div className="bg-gradient-to-r from-green-600 to-green-700 text-white py-3 px-4 text-center sticky top-0 z-50 shadow-lg" data-id="element-345">
      <div className="max-w-7xl mx-auto" data-id="element-346">
        <p className="text-sm md:text-base font-bold tracking-wide" data-id="element-347">
          🔥 OFERTA DE LANZAMIENTO ACTIVA | PRECIO ESPECIAL | 4 MENTORÍAS EN
          VIVO + 5 BONOS
        </p>
      </div>
    </div>;
}